
export const { default: IconEdit } = require("./IconEdit");
export const { default: IconTrash } = require("./IconTrash");
export const { default: IconUpdate } = require("./IconUpdate");
export const { default: IconCancel } = require("./IconCancel");
export const { default: IconAdd } = require("./IconAdd");
export const { default: IconExport } = require("./IconExport");
export const { default: IconDelete } = require("./IconDelete");
export const { default: IconFilter } = require("./IconFilter");
export const { default: IconSave } = require("./IconSave");
export const { default: IconFile } = require("./IconFile");